export const findChatSearchMatches = (messages = [], normalizedTerm = "") => {
  const matches = [];
  if (!normalizedTerm || !Array.isArray(messages) || !messages.length) {
    return matches;
  }

  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const message = messages[index];
    if (!message) continue;

    const searchableFields = [
      message.message,
      message.fileName,
      message.childCompanyName,
      message.country,
      message.region,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    if (searchableFields.includes(normalizedTerm)) {
      matches.push({
        messageId: message._id || null,
        fallbackIndex: index,
        timestamp: message.timestamp || null,
      });
    }
  }

  return matches;
};
